import React from 'react';
//import { Link } from 'react-router-dom';
import styles from './TopNavBar.module.css';

function TopNavBar() {
    return (
        <nav className={styles.nav}>
            <div className={styles.inner}>
            <div className={styles.title}>Connected To Science</div>
            <div className={styles.links}>
                <a href="/">Home</a>
                <a href="/about">About</a>
                <div className={styles.dropdown}>
                    <button className={styles.dropbtn}>Pages ▾</button>
                    <div className={styles.dropdownContent}>
                <a href="/world-countries-quiz">Geography Quizzes</a>
                <a href="/forest-diversity">SID</a>
                <a href="/bird-map">Bird Map</a>
                <a href="/biotic-index">Biotic Index</a>
                <a href="/moon-cards">Moon Phases</a>
                <a href="/labs">Labs (D3)</a>
                <a href="/rock-cycle-canvas">Diagram Canvas</a>
            </div>
        </div>
            </div>
    </div>
</nav>
);
}

export default TopNavBar;
